import { Field, FieldProps } from "@rjsf/utils";
import React from "react";
import Markdown from "markdown-to-jsx";

export const MarkdownField: Field = (props: FieldProps) => {
  const { classNames, schema } = props;
  if (!schema.description) {
    return <></>;
  }
  return <Markdown className={`form-markdown ${classNames ?? ""}`}>{schema.description}</Markdown>;
};
